import PropTypes from 'prop-types';
import * as React from 'react';
import { isEmpty, get, attempt } from 'lodash';
import Checkbox from 'components/Checkbox';
import StaticPage from '../../../pages/Checkout/StaticPage';
import getImageUrl from 'utils/getImageUrl';
import { trackOBDKnowMoreLinkClick } from 'pages/Checkout/CheckoutPageAnalytics';
import styles from './OpenBoxDeliveryWidget.css';
const IMAGE_SIZE = 200;
export default class OpenBoxDeliveryWidget extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = ({ checked }) => {
            const { onSelection } = this.props;
            this.setState({ checked }, () => {
                if (typeof onSelection === 'function') {
                    attempt(onSelection, checked);
                }
            });
        };
        this.showKnowMorePopup = pageId => () => {
            trackOBDKnowMoreLinkClick(this.props.itemForTracking);
            this.context.modal.show({
                children: <StaticPage pageId={pageId}/>,
                classNames: {
                    dialog: styles['open-box-dialog']
                },
                closeButton: true,
                closeOnOverlayClick: true
            });
        };
        this.state = {
            checked: get(props, 'value.selected', false)
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ checked: get(nextProps, 'value.selected', false) });
    }
    render() {
        const { value, data } = this.props;
        const { displayText = '', imageUrl = '', action = undefined } = (data && data.itemObdData) || {};
        const { actionText = '', url = '' } = action || {};
        if (isEmpty(value) || !displayText) {
            return null;
        }
        const modifiable = false;
        const selected = value.selected || false;
        return (<div className={styles['content']}>
				{modifiable ? (<Checkbox checked={selected} className={styles['info-checkbox']} onChange={this.handleChange}/>) : null}
				<div className={styles['info-content']}>
					<div className={styles['image-container']}>
						{imageUrl && <img className={styles['image']} src={getImageUrl(imageUrl, IMAGE_SIZE)}/>}
					</div>
					<div className={styles['info']}>
						{displayText}
						<div>
							{actionText && url ? (<span onClick={this.showKnowMorePopup(url)} className={styles['link']}>
									{actionText}
								</span>) : null}
						</div>
					</div>
				</div>
			</div>);
    }
}
OpenBoxDeliveryWidget.contextTypes = {
    modal: PropTypes.object
};
